import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Checkbox, Button, Input} from 'antd';
import { CheckOutlined, DeleteFilled, SearchOutlined } from '@ant-design/icons';
import apiConnect from '../../../config/apiConfig';
import style from './newCombo.module.scss';
import {MIN_QUANTITY_VALUE, message} from '../../utils/Utils';

const NewCombo = ({productsForComboEdit}) => { // eslint-disable-line
  const {
    container,
    title,
    titleSpan,
    inpLimitCombo,
    tableContainer,
    table,
    tableHeader,
    itemHeader,
    tableBody,
    itemBody,
    inpNumber,
    sidebar,
    sidebarRows,
    titleSidebar,
    sidebarBtn,
    btnBack,
    btnConfirm,
    sidebarItems,
    btnDelete,
    iconDelete,
    siedebarItemName,
    searchContainer,
    titleComboLimit,
    titleLayout,
    inpComboType,
    divider,
  } = style;

  const [userStand, setUserStand] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [productListTotal, setProductListTotal] = useState([]);
  const [comboName, setComboName] = useState('');
  const [description, setDescription] = useState('');
  const [paymentDeadline, setPaymentDeadline] = useState('');
  const [products, setProducts] = useState({});
  const [inputSearch, setInputSearch] = useState('');

  const { search } = useLocation();
  const history = useHistory();

  const { Search } = Input;

  const query = new URLSearchParams(search);
  useEffect(() => {
    setComboName(query.get('name'));
    setDescription(query.get('description'));
    setPaymentDeadline(query.get('paymentDeadline'));

    
    if(query.get('action') === 'edit'){
      let productsUpdated = {};
      productsForComboEdit.forEach(product => {
        
        productsUpdated[product.product._id] = {
          codLab: product.product.codLab,
          codArticle: product.product.codArticle,
          barcode: product.product.barcode,
          description: product.product.description,
          idArticle: product.product.idArticle,
          pharmacyPrice: product.product.pharmacyPrice,
          publicPrice: product.product.publicPrice,
          _id: product.product._id,
          checkbox: true,
          minQuantity: product.minQuantity || MIN_QUANTITY_VALUE,
          maxQuantity: product.maxQuantity,
          discount: product.discount * 100,
        };
      });
      setProducts(productsUpdated);
    }
  }, []);

  useEffect(() => {
    if (userStand.length <= 0) {
      getStand();
    } else {
      getProducts();
    }
  }, [userStand]);

  const getStand = async () => {
    try {
      const { data } = await apiConnect.get(`/stands/${query.get('stand')}`);
      setUserStand(data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const getProducts = async () => {
    try {
      if (userStand.labs.length === 0) {
        message.error('Este stand no tiene productos habilitados por favor contacte con un administrador para poder crear un combo', 10);
        return;
      }
      const { data } = await apiConnect.get(
        `/products?labs=[${userStand.labs}]`,
      );
      setProductsList(data.data[0].products);
      setProductListTotal(data.data[0].products);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  };

  const handleChange = (name, id, e, product) => {
    let productsUpdated;

    if (name === 'checkbox') {
      productsUpdated = {
        ...products,
        [id]: {
          ...products[id],
          [name]: e.target.checked,
          codLab: product.codLab,
          codArticle: product.codArticle,
          barcode: product.barcode,
          description: product.description,
          idArticle: product.idArticle,
          pharmacyPrice: product.pharmacyPrice,
          publicPrice: product.publicPrice,
          _id: product._id,
          minQuantity: MIN_QUANTITY_VALUE,
          maxQuantity: 0,
          discount: 0,
        },
      };

      if (!e.target.checked) delete productsUpdated[id];
    } else if (name === 'delete') {
      productsUpdated = { ...products };

      delete productsUpdated[id];
    } else if (name === 'discount') {
      let value = e.target.value;

      if (e.target.value < 0) value = 0;
      if (e.target.value > 100) value = 100;

      productsUpdated = {
        ...products,
        [id]: {
          ...products[id],
          [name]: value,
        },
      };
    } else {
      productsUpdated = {
        ...products,
        [id]: {
          ...products[id],
          [name]: parseFloat(e.target.value < 0 ? 0 : e.target.value),
        },
      };
    }
    setProducts(productsUpdated);
  };

  const createCombo = () => {

    const newCombo = {};
    newCombo.description = description;
    newCombo.starred = false;
    newCombo.paymentDeadline = paymentDeadline;
    newCombo.totalItemsQuantity = parseInt(query.get('comboQuantity'));
    newCombo.closedCombo = query.get('comboType') === 'abierto' ? false : true;
    newCombo.name = comboName;
    newCombo.stand = query.get('stand');

    const productsArray = Object.keys(products).map((product) => {
      return products[product];
    });

    newCombo.products = productsArray;
    return newCombo;
  };

  const handleSubmit = async () => {
    Object.keys(products).forEach(product => {
      if(products[product].maxQuantity < products[product].minQuantity && products[product].maxQuantity !== 0){
        message.error('Todas las cantidades máximas deberían ser mayores a las cantidades mínimas a menos que la cantidad máxima sea 0', 5);
        return ;
      }
    });

    const newCombo = createCombo();

    newCombo.products.map((product) => {
      product.product = product._id;
      product.discount /= 100;
    });

    try {
      if(query.get('action') === 'edit'){
        await apiConnect.put(`/combos/${query.get('id')}`, newCombo);
        message.success('Combo actualizado con éxito');
        history.push('/provider/mis-combos');
      }else{
        await apiConnect.post('/combos', newCombo);
        message.success('Combo creado correctamente');
        history.push('/provider/mis-combos');
      }
    } catch (error) {
      console.log(error);
      message.error('Error al crear el combo');
    }

  };

  const handleSearch = (e) => {
    setInputSearch(e.target.value);
    const res = productListTotal.filter((element) => {
      if (
        element.description
          .toString()
          .toLowerCase()
          .includes(inputSearch.toLowerCase())
      )
        return element;      
    });
    setProductsList(res);
  };

  return (
    <div className={container}>
      <h3 className={title}>
        Agregar productos a <span className={titleSpan}>{comboName}</span>
      </h3>
      <div className={searchContainer}>
        <Search
          placeholder="buscar..."
          onChange={(e) => {
            handleSearch(e);
          }}
          enterButton={<SearchOutlined />}
          value={inputSearch}
        />
      </div>
      <h5 className={titleComboLimit}>Mínimo de productos</h5>
      <Input
        className={inpLimitCombo}
        value={query.get('comboQuantity')}
        readOnly
      />
      <Input
        className={inpComboType}
        value={`combo ${query.get('comboType')}`}
        readOnly
      />
      <div className={tableContainer}>
        <table className={table}>
          <thead>
            <tr className={tableHeader}>
              <th></th>
              <th className={itemHeader}>Descripcion</th>
              <th className={itemHeader}>Codigo de barra</th>
              <th className={itemHeader}>Pcio. Fcia. C/IVA</th>
              <th className={itemHeader}>% Desc.</th>
              <th className={itemHeader}>Pcio. Oferta C/IVA</th>
              <th className={itemHeader}>Min</th>
              <th className={itemHeader}>Max</th>
            </tr>
          </thead>
          <tbody>
            {productsList &&
              productsList.map((product) => {
                const offerPrice = (product.pharmacyPrice - (product.pharmacyPrice * (products[product._id]?.discount / 100))).toFixed(2);
                return (
                  <tr key={product._id} className={tableBody}>
                    <td className={itemBody}>
                      <Checkbox
                        name="checkbox"
                        onChange={(e) =>
                          handleChange('checkbox', product._id, e, product)
                        }
                        checked={products[product._id]?.checkbox || false}
                      />
                    </td>
                    <td className={itemBody}>{product.description}</td>
                    <td className={itemBody}>{product.barcode}</td>
                    <td className={itemBody}>${product.pharmacyPrice}</td>
                    <td className={itemBody}>
                      <input
                        className={inpNumber}
                        disabled={!products[product._id]?.checkbox || false}
                        value={products[product._id]?.discount  || 0}
                        style={products[product._id]?.checkbox ? { backgroundColor: '#fff' } : {}}
                        type="number"
                        name="discount"
                        onChange={(e) =>
                          handleChange('discount', product._id, e)
                        }
                      />
                    </td>
                    <td className={itemBody}>$ { isNaN(offerPrice)? product.pharmacyPrice : offerPrice}</td>
                    <td className={itemBody}>
                      <input
                        className={inpNumber}
                        disabled={!products[product._id]?.checkbox || false}
                        value={products[product._id]?.minQuantity || MIN_QUANTITY_VALUE}
                        style={products[product._id]?.checkbox ? { backgroundColor: '#fff' } : {}}
                        type="number"
                        name="minQuantity"
                        onChange={(e) =>
                          handleChange('minQuantity', product._id, e)
                        }
                      />
                    </td>
                    <td className={itemBody}>
                      <input
                        className={inpNumber}
                        disabled={!products[product._id]?.checkbox || false}
                        value={products[product._id]?.maxQuantity || 0}
                        style={products[product._id]?.checkbox ? { backgroundColor: '#fff' } : {}}
                        type="number"
                        name="maxQuantity"
                        onChange={(e) =>
                          handleChange('maxQuantity', product._id, e)
                        }
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div className={sidebar}>
        <div className={titleLayout}>
          <h3 className={titleSidebar}>{comboName}</h3>
          <hr className={divider} />
        </div>
        <div className={sidebarRows}>
          {Object.keys(products).map((key) => {
            return (
              <>
                <div className={sidebarItems} key={key._id}>
                  <h5 className={siedebarItemName}>
                    {products[key].description}
                  </h5>
                  <Button
                    onClick={(e) =>
                      handleChange('delete', products[key]._id, e)
                    }
                    className={btnDelete}
                  >
                    <DeleteFilled className={iconDelete} />
                  </Button>
                </div>
                <hr className={divider} />
              </>
            );
          })}
        </div>
        <div className={sidebarBtn}>
          <Button
            className={btnBack}
            onClick={() => history.push('/provider/mis-combos')}
          >
            ATRAS
          </Button>
          <Button className={btnConfirm} onClick={() => handleSubmit()}>
            <CheckOutlined />
            CONFIRMAR COMBO
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NewCombo;
